import { render, staticRenderFns } from "./ActiveTrainingMiniatureEcg.vue?vue&type=template&id=0818603c&"
import script from "./ActiveTrainingMiniatureEcg.vue?vue&type=script&lang=js&"
export * from "./ActiveTrainingMiniatureEcg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports